export const PROJECT_KEY_TO_FILTER_ID_MAP = {
	// staging
	TSTTTT: '10324',
	// hello
	FFCLEANUP: '87939',
};
